import _ from 'lodash'

export default {
  props: {
    dados: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: this.valoresIniciaisForm(),
      novoRegistro: true,
    }
  },
  watch: {
    dados(val) {
      if (val) {
        this.form = _.assignIn(this.form, val)
        this.novoRegistro = false
      }
    },
  },
  methods: {
    gravar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('gravar', this.retornaCamposGravar())
        }
      })
    },
    sair() {
      this.$router.go(-1)
    },
  },
}
